import {
    LayoutDashboard, MonitorPlay, FolderOpen, ListMusic,
    LayoutTemplate, CalendarClock, CalendarDays,
    AppWindow, BarChart2, ClipboardList, FileVideo,
    Trash2, Key, Layers, Building2, MapPin
} from 'lucide-react';
import Constants from './constants';

const ICON_MAP = {
    [Constants.BRAND_PAGE]: Building2,
    [Constants.DASHBOARD_PAGE]: LayoutDashboard,
    [Constants.BRANCH_PAGE]: MapPin,
    [Constants.BRAND_PLAYLIST_PAGE]: ListMusic,
    [Constants.BRAND_MEDIA_PAGE]: FolderOpen,
    [Constants.BRAND_MEDIA_TRASH_PAGE]: Trash2,
    [Constants.ACTIVITYLOG_PAGE]: ClipboardList,
    [Constants.MEDIALOG_PAGE]: FileVideo,
    [Constants.ANALYTICS_PAGE]: BarChart2,
    [Constants.SCREEN_PAGE]: MonitorPlay,
    [Constants.CAMPAIGN_PAGE]: LayoutTemplate,
    [Constants.CAMPAIGN_CONTENT_PAGE]: LayoutTemplate,
    [Constants.CAMPAIGN_CONTENT_CHANNEL_PAGE]: LayoutTemplate,
    [Constants.TIMELINE_PAGE]: CalendarClock,
    [Constants.LAYOUT_PAGE]: Layers,
    [Constants.PLAYLIST_PAGE]: ListMusic,
    [Constants.MEDIA_PAGE]: FolderOpen,
    [Constants.MEDIA_TRASH_PAGE]: Trash2,
    [Constants.EVENT_PAGE]: CalendarDays,
    [Constants.WIDGET_PAGE]: AppWindow,
    [Constants.LICENSE_PAGE]: Key,
};

export default ICON_MAP;
